function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_110",
  "data-name": "Group 110",
  transform: "translate(-99.73 -123.71)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_109",
  "data-name": "Group 109"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_697",
  "data-name": "Path 697",
  d: "M99.73,123.8h5.52a7.628,7.628,0,0,1,3.3.68,5.131,5.131,0,0,1,2.22,1.94,6.015,6.015,0,0,1,0,5.96,5.188,5.188,0,0,1-2.22,1.94,7.659,7.659,0,0,1-3.3.68H99.73Zm5.36,8.26a2.656,2.656,0,0,0,1.94-.7,3,3,0,0,0,0-3.92,2.714,2.714,0,0,0-1.94-.7h-1.58v5.31h1.58Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_698",
  "data-name": "Path 698",
  d: "M118.14,132.19h-1.02V135h-3.78V123.8h5.39a6.6,6.6,0,0,1,2.7.51,4.149,4.149,0,0,1,1.86,5.81,3.807,3.807,0,0,1-1.57,1.42l2.35,3.46h-4.03Zm1.5-5.13a1.681,1.681,0,0,0-1.15-.34h-1.38v2.62h1.38a1.664,1.664,0,0,0,1.15-.34,1.428,1.428,0,0,0,0-1.94Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_699",
  "data-name": "Path 699",
  d: "M135.03,132.15V135h-9.31V123.8h9.1v2.85h-5.39v1.31h4.74v2.72h-4.74v1.47Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_700",
  "data-name": "Path 700",
  d: "M155.02,123.8,151.44,135h-4.05l-1.81-5.98-1.9,5.98h-4.05l-3.58-11.2h3.89l1.95,6.37,2.06-6.37h3.47l1.95,6.45,2.06-6.45Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_701",
  "data-name": "Path 701",
  d: "M167.36,123.8V135h-3.1L160,129.91V135h-3.68V123.8h3.1l4.26,5.09V123.8Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_702",
  "data-name": "Path 702",
  d: "M169.71,123.8h3.78V135h-3.78Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_703",
  "data-name": "Path 703",
  d: "M183.4,133.05h-4.26l-.75,1.95h-3.84l4.9-11.2h3.71l4.9,11.2h-3.9Zm-1.04-2.72-1.09-2.82-1.09,2.82Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_704",
  "data-name": "Path 704",
  d: "M200.16,123.8V135h-3.1l-4.26-5.09V135h-3.68V123.8h3.1l4.26,5.09V123.8Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_705",
  "data-name": "Path 705",
  d: "M211.83,132.15V135h-9.31V123.8h9.1v2.85h-5.39v1.31h4.74v2.72h-4.74v1.47Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_706",
  "data-name": "Path 706",
  d: "M227.19,124.83a3.858,3.858,0,0,1,0,5.63,5.07,5.07,0,0,1-3.36,1.02h-3.01V135h-1.18V123.8h4.19A5.019,5.019,0,0,1,227.19,124.83Zm-.85,4.87a2.5,2.5,0,0,0,.88-2.06,2.552,2.552,0,0,0-.88-2.09,3.922,3.922,0,0,0-2.54-.73h-2.98v5.6h2.98A3.883,3.883,0,0,0,226.34,129.7Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_707",
  "data-name": "Path 707",
  d: "M237.7,134.35a5.449,5.449,0,0,1-2.11-2.04,5.951,5.951,0,0,1,0-5.82,5.518,5.518,0,0,1,2.11-2.04,6.492,6.492,0,0,1,6.02,0,5.418,5.418,0,0,1,2.1,2.04,5.922,5.922,0,0,1,0,5.84,5.418,5.418,0,0,1-2.1,2.04,6.118,6.118,0,0,1-3,.74A6.208,6.208,0,0,1,237.7,134.35Zm5.41-.91a4.391,4.391,0,0,0,1.68-1.66,4.948,4.948,0,0,0,0-4.76,4.391,4.391,0,0,0-1.68-1.66,4.8,4.8,0,0,0-2.4-.6,4.869,4.869,0,0,0-2.41.6,4.445,4.445,0,0,0-1.7,1.66,4.878,4.878,0,0,0,0,4.76,4.375,4.375,0,0,0,1.7,1.66,4.869,4.869,0,0,0,2.41.6A4.8,4.8,0,0,0,243.11,133.44Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_708",
  "data-name": "Path 708",
  d: "M253.08,123.8h4.56a6.758,6.758,0,0,1,3.14.71,5.173,5.173,0,0,1,2.11,1.98,5.982,5.982,0,0,1,0,5.8,5.17,5.17,0,0,1-2.11,1.98,6.729,6.729,0,0,1-3.14.71h-4.56V123.8Zm4.5,10.18a5.453,5.453,0,0,0,2.58-.58,4.179,4.179,0,0,0,1.71-1.62,4.655,4.655,0,0,0,.61-2.38,4.559,4.559,0,0,0-.61-2.38,4.306,4.306,0,0,0-1.71-1.62,5.425,5.425,0,0,0-2.58-.58h-3.31v9.15h3.31Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_709",
  "data-name": "Path 709",
  d: "M270.46,123.8h1.18v10.18h6.27V135h-7.46V123.8Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_710",
  "data-name": "Path 710",
  d: "M292.43,132.01h-6.24L284.85,135h-1.23l5.12-11.2h1.17l5.12,11.2h-1.25Zm-.43-.96-2.69-6.02-2.69,6.02Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_711",
  "data-name": "Path 711",
  d: "M302.54,134.7a4.463,4.463,0,0,1-1.77-1.06l.46-.91a4.357,4.357,0,0,0,1.62.98,5.935,5.935,0,0,0,2.08.38,3.826,3.826,0,0,0,2.26-.55,1.709,1.709,0,0,0,.75-1.43,1.424,1.424,0,0,0-.41-1.07,2.971,2.971,0,0,0-1-.62c-.4-.14-.94-.3-1.65-.47a16.853,16.853,0,0,1-2.02-.62,3.424,3.424,0,0,1-1.29-.9,2.394,2.394,0,0,1-.54-1.65,2.774,2.774,0,0,1,.45-1.54,3.122,3.122,0,0,1,1.38-1.11,5.594,5.594,0,0,1,2.3-.42,6.992,6.992,0,0,1,1.88.26,5.544,5.544,0,0,1,1.59.73l-.4.94a5.692,5.692,0,0,0-1.5-.7,5.793,5.793,0,0,0-1.57-.23,3.634,3.634,0,0,0-2.22.57,1.752,1.752,0,0,0-.74,1.46,1.463,1.463,0,0,0,.41,1.08,2.616,2.616,0,0,0,1.02.62c.41.14.96.3,1.66.47a15.413,15.413,0,0,1,1.99.6,3.275,3.275,0,0,1,1.29.9,2.376,2.376,0,0,1,.53,1.62,2.682,2.682,0,0,1-.46,1.54,3.047,3.047,0,0,1-1.4,1.1,5.875,5.875,0,0,1-2.32.41A6.825,6.825,0,0,1,302.54,134.7Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_712",
  "data-name": "Path 712",
  d: "M316.27,123.8h1.18V135h-1.18Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_713",
  "data-name": "Path 713",
  d: "M333.47,133.98V135h-7.92V123.8h7.68v1.02h-6.5v3.98h5.79v1.01h-5.79v4.16h6.74Z",
  fill: "#fff"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233.74,
    height: 11.4,
    viewBox: "0 0 233.74 11.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.b6c5e372.svg";
export { ForwardRef as ReactComponent };